




























import { Component, Vue, Watch } from 'vue-property-decorator';
import { padHeadPanel2 } from "@/components";
import info from "./components/info.vue";
import supplier from "./components/supplier.vue";
import inventory from "./components/inventory.vue";
import fullinventory from "./components/fullinventory.vue";
@Component({
    components: {
        padHeadPanel2,info,supplier,inventory,fullinventory
    },
})
export default class stock extends Vue {

    active='kccx';

    userInfo = {};
   
    public $refs: {
    };
    created() {
        this.userInfo = JSON.parse(localStorage.getItem("padUserinfo"));
    }
    mounted(){
        let allotactive = localStorage.getItem("allotactive")
        ? Number(localStorage.getItem("allotactive"))
        : 0;
        this.active = allotactive==0?'kccx':allotactive==1?'kcpd':allotactive==2?'qkpd':'gys';  
        // this.active = allotactive==0?'kccx':allotactive==1?'kcpd':'gys'; 
        localStorage.removeItem('allotactive'); 
    }
    /**判断权限 */
    hasAuth(auth) {
        let val = false;
        let btnPermissionsStr = this.userInfo['authorityJson']?this.userInfo['authorityJson'].split(','):null;
        if (btnPermissionsStr == undefined || btnPermissionsStr == null) {
        val = false;
        }
        if (btnPermissionsStr&&btnPermissionsStr.some(v=>v==auth)) {
        val = true;
        }
        return val;
    }
   
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/stock/stock.vue